import React from 'react';
import { Route, Routes } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';

export const DashboardRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<DashboardPage />} />
    </Routes>
  );
};
